(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-yas"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function(){
 
  // acordion
  const items = document.querySelectorAll(".faq_yas .accordion button");
	const itemsWrapp = document.querySelectorAll(".accordion-item");
        function toggleAccordion() {
          const itemToggle = this.getAttribute('aria-expanded');
		  const itemWrapToggle = this.closest("div").getAttribute('aria-open');
          for (i = 0; i < items.length; i++) {
            items[i].setAttribute('aria-expanded', 'false');
            itemsWrapp[i].setAttribute('aria-open', 'false');
          }

          if (itemToggle == 'false') {
            this.setAttribute('aria-expanded', 'true');
            this.closest("div").setAttribute('aria-open', 'true');
          }
        }

   items.forEach(item => item.addEventListener('click', toggleAccordion)); 
   
});


  } catch(e) { console.error(e); }
})();
})();
